import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default function createWobbleModel({ scene, gltfLoader, wobble, url })
{
  let root = null

  gltfLoader.load(url, (gltf) =>
  {
    root = gltf.scene

    root.traverse((child) =>
    {
      if (!child.isMesh) return

      const geo = child.geometry

      if (!geo.attributes.uv)
      {
        console.warn('No UVs, cannot compute tangents:', child.name)
        return
      }

      if (!geo.index)
        child.geometry = mergeVertices(geo)

      if (!child.geometry.attributes.normal)
        child.geometry.computeVertexNormals()

      child.geometry.computeTangents()
      child.rotation.y = Math.PI
      child.material = wobble.material
      child.customDepthMaterial = wobble.depthMaterial
      child.castShadow = true
      child.receiveShadow = true
    })

    scene.add(root)
  })

  return {
    getRoot: () => root
  }
}
